import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Grid, makeStyles } from '@material-ui/core';
import { ProductCard } from './components';
import { setProducts } from 'actions';
import PaginationView from './components/pagination';
import BaseSkeleton from 'views/UIWidgets/BaseSkeleton';

export const useStyles = makeStyles(theme => ({
	root: {
		padding: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(2),
	},
}));

const ProductList = ({ query, setProducts }) => {
	const classes = useStyles();

	const [products, setProduct] = useState({});

	const [currentPage, setCurrentPage] = useState(1);

	const [totalResult, setTotalResult] = useState(0);

	const [totalPages, setTotalPages] = useState(0);

	const [loading, setLoading] = useState(false);

	const [error, setError] = useState(false);

	const numberPerPage = 12;

	const getProducts = async () => {
		setLoading(true);

		try {
			const res = await axios.get('/api/products', {
				params: {
					currentPage: currentPage,
					numberPerPage: numberPerPage,
					...query,
				},
			});
			const data = res.data.data;

			setProduct({
				...products,
				[currentPage]: data.products,
			});
			setTotalResult(data.totalResult);
			setTotalPages(data.totalPages);

			setProducts(data.products);
		} catch (error) {
			setError(true);
			console.log('getProducts error', error);
		}

		setLoading(false);
	};

	const prevQuery = useRef();
	prevQuery.current = query;

	useEffect(() => {
		if ((!error && !loading) || prevQuery.current !== query) getProducts();
		prevQuery.current = query;
	}, [currentPage, error, query]);

	const pageLess = () => {
		if (currentPage > 1) setCurrentPage(currentPage - 1);
	};

	const pageMore = () => {
		if (currentPage < totalPages) setCurrentPage(currentPage + 1);
	};

	return (
		<>
			<div className={classes.content}>
				{loading ? (
					<BaseSkeleton />
				) : (
					<Grid container spacing={3}>
						{products &&
							products[currentPage] &&
							products[currentPage].map(product => (
								<Grid item key={product._id} lg={3} md={4} xs={6}>
									<ProductCard product={product} />
								</Grid>
							))}
					</Grid>
				)}
			</div>
			<PaginationView
				currentPage={currentPage}
				numberPerPage={numberPerPage}
				totalResult={totalResult}
				pageLess={pageLess}
				pageMore={pageMore}
			/>
		</>
	);
};

export default connect(null, { setProducts })(ProductList);
